import React from 'react';
import Button from "../button/button.jsx";
import {FaPen, FaTrash} from "react-icons/fa";

const GenericEditRemoveCellRenderer = ({data, setData, setOpen, remove, noEdit = true}) => {
    const edit = () => {
        setOpen(true)
        setData(data)
    }

    return (
        <div className="flex gap-1 justify-center items-center h-full w-full">
            {
                noEdit &&
                <Button onClick={edit} className={"w-7.5! h-6.25! p-0!"} title={"Editar"}>
                    <FaPen />
                </Button>
            }
            <Button target={"danger"} onClick={() => remove(data)} className={"w-7.5! h-6.25! p-0!"} title={"Remover"}>
                <FaTrash />
            </Button>
        </div>
    );
};

export default GenericEditRemoveCellRenderer;